import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import i18n from 'i18n-js';

import { theme } from 'config/theme';
import { TableMapDraft } from '../context';
import MapEditorCanvas, { ROOM } from './MapEditorCanvas';
import TableFigure from './TableFigure';

const useStyles = makeStyles({
    previewCard: {
        flex: '1 1 0',
        minWidth: 0,
        border: `1px solid ${theme.palette.grey['300']}`,
        borderRadius: 8,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
    },
    previewCardHeader: {
        padding: '14px 16px 10px',
        borderBottom: `1px solid ${theme.palette.grey['300']}`,
        backgroundColor: theme.palette.common.white,
    },
    cardHeading: {
        fontSize: 13,
        fontWeight: 600,
        color: theme.palette.text.secondary,
        letterSpacing: 0.5,
        textTransform: 'uppercase' as const,
    },
    canvasWrapper: {
        height: 360,
        backgroundColor: '#fafafa',
    },
});

interface TableMapPreviewProps {
    draft: TableMapDraft;
}

export default function TableMapPreview({ draft }: TableMapPreviewProps) {
    const classes = useStyles();

    return (
        <div className={classes.previewCard}>
            <div className={classes.previewCardHeader}>
                <Typography className={classes.cardHeading}>
                    {i18n.t('tableMaps.wizard.review.tableMapPreview')}
                </Typography>
            </div>
            <div className={classes.canvasWrapper}>
                <MapEditorCanvas
                    gridEnabled={draft.gridEnabled}
                    zoom={1}
                    entrance={draft.entrance}
                    isMarkingEntrance={false}
                    onSelectWall={() => undefined}
                    onMoveEntrance={() => undefined}
                >
                    {draft.tables.map((table) => {
                        const cx = ROOM.x + table.x * ROOM.width;
                        const cy = ROOM.y + table.y * ROOM.height;
                        return (
                            <g
                                key={table.id}
                                transform={`translate(${cx}, ${cy})`}
                                pointerEvents="none"
                            >
                                <TableFigure
                                    width={table.width * ROOM.width}
                                    height={table.height * ROOM.height}
                                    seats={table.seats}
                                    shape={table.shape}
                                    label={table.label}
                                    isActive={table.isActive}
                                />
                            </g>
                        );
                    })}
                </MapEditorCanvas>
            </div>
        </div>
    );
}
